import { CSSProperties, useEffect, useState } from 'react';

import Badge from '../badge';
import './UserAvatar.scss';

export interface IUserAvatarProps {
  className?: string;
  picture?: string;
  size?: 'big' | 'small';
  badge?: string | number;
}

export const UserAvatar = ({ picture, className, size, badge }: IUserAvatarProps) => {
  const [isError, setIsError] = useState(false);
  const sizeClass = size ? ` ${size}` : '';
  const customClass = className ? ` ${className}` : '';
  const avatarClass = `user-avatar${sizeClass}${customClass}`;
  const avatarStyles: CSSProperties = {};
  if (picture && !isError) {
    avatarStyles.backgroundImage = `url("${picture}")`;
  }
  useEffect(() => {
    if (!picture) {
      return;
    }
    const image = new Image();
    image.src = picture;
    function errorHandler() {
      setIsError(true);
    }
    image.addEventListener('error', errorHandler);
    return () => {
      image.removeEventListener('error', errorHandler);
    };
  }, [picture, setIsError]);
  const badgeItem = badge ? (
    <Badge color="green" className="user-menu-badge">
      {badge}
    </Badge>
  ) : null;
  return (
    <span className="avatar-container">
      <span className={avatarClass} style={avatarStyles} />
      <span className="menu-badge">{badgeItem}</span>
    </span>
  );
};

export default UserAvatar;
